module.exports = __webpack_public_path__ + "assets/img/Black.62fd6fe3.svg";